import * as React from "react";

const ShoppingCart = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    viewBox={"0 0 24 24"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 22.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM18 22.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m5.17 7.5 16.33 1-1.68 6.39a2 2 0 0 1-2 1.61H7.25a2 2 0 0 1-2-1.74L3.73 3.24A2 2 0 0 0 1.75 1.5"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShoppingCart;
